import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Wrapper = styled.div`
  position: relative;
  .uk-icon-button {
    margin: 0 auto;
  }
  .to-top {
    right: 15px;
    bottom: 15px;
  }
`;

const ToTop = props => {
  return (
    <Wrapper className="common-to-top">
      <div className="to-top uk-flex uk-flex-column uk-align-center uk-margin-auto uk-margin-remove-top uk-margin-remove-bottom uk-position-absolute">
        <button
          className="uk-icon-button uk-dark"
          data-uk-totop
          data-uk-scroll
          aria-label="Scroll to top"
        ></button>
      </div>
    </Wrapper>
  );
};
ToTop.propTypes = {
  bg: PropTypes.string,
};
export default ToTop;



// WEBPACK FOOTER //
// ./src/features/common/ToTop.js